const select = (state, map) => map[state?.language] || map[Object.keys(map)[0]];

export const createImagesModule = () => {
  return {
    state: {},
    getters: {
      image_zusammensetzung: (state, getters, rootState) => {
        return select(rootState, {
          en: require("@/assets/images/slider_zusammensetzung_en.png"),
          de: require("@/assets/images/slider_zusammensetzung.png")
        });
      },
      image_sars_cov_ies: (state, getters, rootState) => {
        return select(rootState, {
          en: require("@/assets/images/sars_cov_ies_en.jpg"),
          de: require("@/assets/images/sars_cov_ies_de.jpg")
        });
      },
      image_main_video_preview: (state, getters, rootState) => {
        return select(rootState, {
          en: require("@/assets/images/main_video_preview_en.jpg"),
          de: require("@/assets/images/main_video_preview_de.jpg")
        });
      },
      image_slider_partikel: (state, getters, rootState) => {
        return select(rootState, {
          en: require("@/assets/images/slider_partikel_en.png"),
          de: require("@/assets/images/slider_partikel.png")
        });
      },
      image_button_prospekt: (state, getters, rootState) => {
        return select(rootState, {
          en: require("@/assets/images/button_prospekt_en.png"),
          de: require("@/assets/images/button_prospekt.png")
        });
      },
      image_slider_lunge: () => {
        return require("@/assets/images/slider_lunge.png");
      },
      image_slider_kohlenmonoxid: () => {
        return require("@/assets/images/slider_kohlenmonoxid.png");
      },
      image_arrow_white_prev: () => {
        return require("@/assets/images/arrow_white_prev.png");
      },
      image_arrow_white: () => {
        return require("@/assets/images/arrow_white.png");
      },
      image_checkmarkicon_black: () => {
        return require("@/assets/images/checkmarkicon_black.png");
      },
      image_play_button_white: () => {
        return require("@/assets/images/play_button_white.png");
      },
      image_button_filme_instrumente: () => {
        return require("@/assets/images/button_filme_instrumente.png");
      },
      image_downloads_ies_cov: () => {
        return require("@/assets/images/downloads_ies-cov.png");
      },
      image_downloads_prospekt: () => {
        return require("@/assets/images/downloads_prospekt.jpg");
      },
      image_downloads_smoke_evacuation: () => {
        return require("@/assets/images/image_downloads_smoke_evacuation.jpg");
      },
      image_downloads_flipbook: () => {
        return require("@/assets/images/downloads_flipbook.jpg");
      },
      image_zubehoer_wasserfalle: () => {
        return require("@/assets/images/zubehoer_wasserfalle.jpg");
      },
      image_zubehoer_aktivierungsvorrichtung: () => {
        return require("@/assets/images/zubehoer_aktivierungsvorrichtung.jpg");
      },
      image_zubehoer_t_stueck: () => {
        return require("@/assets/images/zubehoer_t-stueck.jpg");
      },
      image_zubehoer_zentralabsaugung: () => {
        return require("@/assets/images/zubehoer_zentralabsaugung.jpg");
      },
      image_zubehoer_lapschlauch: () => {
        return require("@/assets/images/zubehoer_lapschlauch.jpg");
      },
      image_zubehoer_fussschalter: () => {
        return require("@/assets/images/zubehoer_fussschalter.jpg");
      },
      image_button_prospekt_without_text: () => {
        return require("@/assets/images/button_prospekt.png");
      },
      image_button_arrow_right: () => {
        return require("@/assets/images/button_arrow_right.png");
      },
      image_bg_smoke_header: () => {
        return require("@/assets/images/bg_smoke_header.jpg");
      },
      image_background_downloads: () => {
        return require("@/assets/images/background-downloads.jpg");
      },
      image_background_ies_2: () => {
        return require("@/assets/images/background-ies-2.jpg");
      },
      image_downloads_ies_webcast: () => {
        return require("@/assets/images/downloads_ies-webcast.png");
      },
      image_downloads_ies3_with_surgical_units: () => {
        return require("@/assets/images/downloads_ies3_with_surgical_units.jpg");
      }
    }
  };
};
